import { Badge, BadgeProps, Box, Icon, Stack, Text } from '@chakra-ui/core'
import { Maybe } from 'graphql/jsutils/Maybe'
import React from 'react'
import { VscLink } from 'react-icons/vsc'
import * as VscIcons from 'react-icons/vsc'
import { Enum_Task_Status } from '../../generated/graphql'
import { statusHelper, getStatusLabel } from '../../utils'

type StatusBadgeProps = BadgeProps & {
  status?: Maybe<Enum_Task_Status> | string
  indicator?: boolean
  withIcon?: boolean
}
const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  indicator,
  children,
  variantColor,
  onClick,
  withIcon,
  ...rest
}) => {
  const { color, title, icon } = statusHelper(status || '', false)
  const hasStatus = !indicator && status
  // turn the icon string into a component
  const IconComponent = (VscIcons as any)[icon] as React.ElementType
  return (
    <Badge
      variant="subtle"
      textTransform="capitalize"
      p={0}
      color={!hasStatus ? `${variantColor}.700` : `${color}.700`}
      borderRadius="md"
      isTruncated
      display="flex"
      alignItems="center"
      justifyContent="center"
      fontSize="xx-small"
      cursor={onClick ? 'pointer' : undefined}
      variantColor={!hasStatus ? variantColor : color}
      onClick={onClick}
      bg="transparent"
      {...rest}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box
          {...((status || indicator) && !withIcon
            ? {
                content: '""',
                boxSize: 1,
                display: 'inline-flex',
                mr: 2,
                border: '2px solid green',
                borderRadius: 'full',
                bg: !hasStatus ? `${variantColor}.500` : `${color}.500`
              }
            : {})}
        />
        {withIcon && (
          <Icon
            as={IconComponent}
            color={!hasStatus ? `${variantColor}.600` : `${color}.600`}
            fontSize="xs"
          />
        )}
        <Text wordBreak="break-all" mr={onClick ? 2 : 0} fontSize="x-small">
          {status && title ? getStatusLabel(title) : children}
        </Text>
        {onClick && <VscLink />}
      </Stack>
    </Badge>
  )
}
StatusBadge.defaultProps = {
  variantColor: 'blue'
}
export default StatusBadge
